// extracted by mini-css-extract-plugin
export default {"title":"SectionTitle_title__BtVRh","swoosh":"SectionTitle_swoosh__nCh1D"};